import {BeginnerModeLevel} from '@colonist/game-beginner-mode'
import {UIGameManager} from '../../UIGameManager'
import {UIGameBeginnerModeGoalsController} from '../UIGameBeginnerModeGoalsController'
import {BeginnerModeActionState} from '@colonist/game-state-types'

export class UIGameBeginnerModeHelpersController {
    private readonly uiGameManager: UIGameManager
    private readonly currentLevel: BeginnerModeLevel
    private goalsController: UIGameBeginnerModeGoalsController

    constructor(uiGameManager: UIGameManager, level: BeginnerModeLevel) {
        if(level != BeginnerModeLevel.Level1) return
        this.uiGameManager = uiGameManager
        this.currentLevel = level

        this.goalsController = new UIGameBeginnerModeGoalsController(uiGameManager, level)
    }

    updateHelpers(data?: BeginnerModeActionState) {
        if(data == undefined) return
        if(this.uiGameManager?.gameState.isGameOver) return
        if(data.numberOfRemainingGoals >= 0) this.goalsController?.updateGoals(data.numberOfRemainingGoals)
    }

    onCanvasResized(data: BeginnerModeActionState) {
        if(this.currentLevel != BeginnerModeLevel.Level1) return

        this.goalsController?.destroy()
        if(this.uiGameManager?.gameState.isGameOver) return

        this.goalsController = new UIGameBeginnerModeGoalsController(this.uiGameManager, this.currentLevel)
        this.goalsController.updateGoals(data.numberOfRemainingGoals)
    }
}
